export const DATE_MASK = {
    full: 'MM/dd/yyyy hh:mm:ss a',
    withoutTime: 'MM/dd/yyyy',
    shortYear: 'MM/dd/yy',
    onlyHours: 'hh a',
};
